const en = {
  poweredBy: 'Powered by',
  firstBehaviorAgent: 'First Behavior + UX Agent on OpenAI',
  ratings: 'Ratings',
  productivity: 'Productivity',
  category: 'Category',
  conversations: 'Conversations',
  download: 'Download',
  inDevelopment: 'In Development',
  open: 'Open',
};

export default en;
